import React, { useState, useEffect, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import { TextInput } from "../../../Components/Input/Input";
import { ButtonSave, ButtonClose} from "../../../Components/Button/Button";
import axios from "axios";
import { UrlApi, authorization} from "../../../UrlApi/UrlApi";
import Loading from "../../../Components/Loading/Loading";
import { AlertError, AlertSuccess, AlertWarning} from "../../../Components/AlertDialog/AlertDialog";
import SelectAutoComplete from "../../../Components/Input/Input";
import Box from "@mui/material/Box";
import { userData } from "../../../DataContext/DataContext";
import { useRecoilValue } from "recoil";
import Card from '@mui/material/Card';
import DataTable from "../../../Components/DataTable/DataTable";
import { createTheme, ThemeProvider } from "@mui/material/styles";


function EditAssignPermissions(props) {
    const user = useRecoilValue(userData);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(50);
    const [menuData, setMenuData] = useState([]);

    const columns = [
        {
            title: "เมนู",
            field: "master_menu_name",
            filtering: false,            
        },
        
    ];

    const onSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        await axios.post(UrlApi+'save_menu_data_permissions_role', menuData, authorization).then((res)=>{
            if(res.data.status === 1){
                props.onCancel();
                AlertSuccess(res.data.message);
                setLoading(false);
            }else{
                AlertError(res.data.message);
                setLoading(false);
            }
        }).catch((err)=>{
            setLoading(false);
            AlertError(err);
        });
    };

    const getData = async () => {
        setLoading(true);
        await axios.post(UrlApi+'get_menu_data_permissions_role', {roleGroupId: props.roleGroupId}, authorization).then((res)=>{
            res.data.map((item)=>{
                item.tableData = { checked: item.role_menu_active }
            });
            setMenuData(res.data);
            setLoading(false);
        }).catch((err)=>{
            setLoading(false);
            AlertError(err);
        }); 
    };

    const theme = createTheme({
        palette: {
          primary: {
            main: '#4caf50',
          },
          secondary: {
            main: '#ff0000',
          },
        },
    
    });

    useEffect(()=>{
        getData();
    }, []);
    return (
        <>
            <ThemeProvider theme={theme}>
                <Dialog open={props.open} maxWidth="1500" PaperProps={{style: { borderRadius: 10, width: '40rem'}}}>
                <Box component="form" noValidate onSubmit={onSubmit} sx={{ mt: 1}}>
                    <DialogTitle>
                    <label>{props.roleGroupName}</label>
                    </DialogTitle>
                    <DialogContent dividers="paper">
                        <Card variant="outlined" style={{paddingLeft: '10px', paddingRight: '10px', borderRadius: '10px'}}>
                        
                            <DataTable
                                selection={true}               
                                columns={columns}
                                data={menuData}
                                exportButton={false}
                                onSelectionChange={(rowData, data)=>{
                                    if(data !== undefined){
                                        menuData.map((item)=>{
                                            if(item.role_menu_id === data.role_menu_id){
                                                item.role_menu_active = data.tableData.checked;
                                            }
                                        });
                                    }else{
                                        if(rowData.length === 0){
                                            menuData.map((item)=>{
                                                item.role_menu_active = false;
                                            });
                                        }else{
                                            menuData.map((item)=>{
                                                item.role_menu_active = true;
                                            });
                                        }     
                                    }                                                        
                                }}                 
                                width="100%"
                                countRowData={menuData.length}
                                pageSize={pageSize}
                            />                        
                        </Card>       
                    </DialogContent>
                    <DialogActions>
                    <ButtonSave
                        type="submit"
                    />
                    <ButtonClose
                        onClick={() => props.onCancel()}//
                    />
                    </DialogActions>
                    <Loading open={loading}/>
                    </Box>
                </Dialog>
            </ThemeProvider>      
        </>
    );
}

export default EditAssignPermissions;
